import { BFF_PROXY_API } from 'constants/apiRoutes';

import { axiosWithoutRetries } from 'shared/api/requestInstance';

/**
 * @deprecated использовать RTK Query вместо axios
 * */
export const validatePassport = async (passport: string): Promise<boolean | null> => {
  try {
    const { data: isValid } = await axiosWithoutRetries.post<boolean>(BFF_PROXY_API.validatePassport, {
      passport,
    });

    return isValid;
  } catch {
    return null;
  }
};
